import { useDispatch } from 'react-redux';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import { IconButton } from '@interstate/components/IconButton';
import { TrashIcon, ArrowUturnLeftIcon } from '@interstate/components/Icons';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';

type TradeItemHeaderProps = {
    originalIndex: number;
    year?: number | string | null;
    make?: string | null;
    model?: string | null;
    isDeleted?: boolean;
};

const TradeItemHeader = ({ originalIndex, year, make, model, isDeleted = false }: TradeItemHeaderProps) => {
    const dispatch = useDispatch();
    const vehicleDetails = [year, make, model].filter(Boolean).join(' ');

    const handleDelete = () => {
        dispatch(tradeInsActionCreators.deleteTradeIn(originalIndex));
    };

    const handleUndo = () => {
        dispatch(tradeInsActionCreators.undoDeleteTradeIn(originalIndex));
    };

    return (
        <Box
            mb={1}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <Typography variant="strong-sm" sx={{ whiteSpace: 'nowrap' }}>
                    {`Trade ${originalIndex + 1}${vehicleDetails ? ':' : ''}`}
                </Typography>
                {vehicleDetails && <Typography variant="body-sm">{vehicleDetails}</Typography>}
            </Box>
            <>
                {!isDeleted ? (
                    <IconButton
                        buttonStyle="tertiary"
                        size="sm"
                        onClick={handleDelete}
                        data-testid={`trade-delete-${originalIndex}`}
                        aria-label="Delete trade"
                    >
                        <TrashIcon />
                    </IconButton>
                ) : (
                    <IconButton
                        buttonStyle="tertiary"
                        size="sm"
                        onClick={handleUndo}
                        data-testid={`trade-undo-${originalIndex}`}
                        aria-label="Undo delete trade"
                    >
                        <ArrowUturnLeftIcon />
                    </IconButton>
                )}
            </>
        </Box>
    );
};

export default TradeItemHeader;
